<script lang="ts">
  import DashCard from '../shared/DashCard.svelte';
  import { Laboratorio, type OrdenLab } from '../../../lib/api';
  import { session } from '../../../lib/auth.svelte';

  let { limit = 6, interactive = false }: { limit?: number; interactive?: boolean } = $props();

  let ordenes = $state<OrdenLab[]>([]);
  let error = $state<string | null>(null);
  let busy = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      const pendientes = await Promise.all([
        Laboratorio.ordenes('SOLICITADA'),
        Laboratorio.ordenes('EN_PROCESO'),
        Laboratorio.ordenes('RESULTADOS_LISTOS'),
      ]);
      ordenes = pendientes.flat().slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  async function validar(id?: string) {
    if (!id) return;
    busy = id;
    try {
      await Laboratorio.validar(id, session.value?.usuario ?? 'lab');
      await cargar();
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      busy = null;
    }
  }

  async function entregar(id?: string) {
    if (!id) return;
    busy = id;
    try {
      await Laboratorio.entregar(id);
      await cargar();
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      busy = null;
    }
  }

  function badge(estado?: string) {
    if (estado === 'RESULTADOS_LISTOS') return 'warn';
    if (estado === 'VALIDADA') return 'ok';
    return '';
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 45000); return () => clearInterval(t); });
</script>

<DashCard title="Cola laboratorio" hint="{ordenes.length} órdenes">
  {#snippet actions()}
    <button type="button" class="btn-sm" onclick={cargar}>↻</button>
  {/snippet}
  {#if error}<p class="err">{error}</p>{/if}
  {#if ordenes.length === 0 && !error}
    <p class="empty">Cola vacía.</p>
  {:else}
    <table class="dash-table">
      <thead>
        <tr>
          <th>Orden</th>
          <th>Paciente</th>
          <th>Estado</th>
          {#if interactive}<th></th>{/if}
        </tr>
      </thead>
      <tbody>
        {#each ordenes as o (o.id)}
          <tr>
            <td class="dash-mono">{o.numero ?? o.id?.slice(0, 8)}</td>
            <td>{o.pacienteNombre ?? 'Paciente'}</td>
            <td><span class="dash-badge {badge(o.estado)}">{o.estado}</span></td>
            {#if interactive}
              <td class="acts">
                {#if o.estado === 'RESULTADOS_LISTOS'}
                  <button type="button" class="btn-ok" disabled={busy === o.id} onclick={() => validar(o.id)}>Validar</button>
                {/if}
                {#if o.estado === 'VALIDADA'}
                  <button type="button" class="btn-sm" disabled={busy === o.id} onclick={() => entregar(o.id)}>Entregar</button>
                {/if}
              </td>
            {/if}
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</DashCard>

<style>
  .btn-sm, .btn-ok { border-radius: 999px; cursor: pointer; padding: 0.22rem 0.55rem; font-size: 0.72rem; font-weight: 600; transition: all 0.2s; }
  .btn-sm { border: 1px solid var(--glass-border); background: var(--glass-bg-card); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); color: var(--text-secondary); }
  .btn-sm:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  .btn-ok { border: 0; background: linear-gradient(135deg, #10b981, #059669); color: #fff; }
  .btn-ok:hover { box-shadow: 0 4px 12px rgba(16,185,129,0.35); transform: translateY(-1px); }
  .acts { white-space: nowrap; }
  .err, .empty { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
  .err { color: var(--danger); }
</style>
